import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getSupportFaqQuestions = (cityName, siteTitle, vehicleType, supportEmail) => [
  {
    question: `How do I book a food ${vehicleType} for my event?`,
    answer: `Booking a food ${vehicleType} through ${siteTitle} is simple. Visit our catering page, submit your event details — including date, location, guest count, and food preferences — and you'll receive custom quotes from available food ${vehicleType}s. You can compare options, message vendors directly, and book the perfect ${vehicleType} for your event.`
  },
  {
    question: `How do I join ${siteTitle} as a food ${vehicleType} vendor?`,
    answer: `Food ${vehicleType} owners can register on our vendor signup page. Once approved, you'll be able to create a profile, showcase your menu, receive catering requests, and connect with customers across ${cityName} and the greater Puget Sound area.`
  },
  {
    question: 'How do I get food trucks at my office, apartment, or property?',
    answer: `${siteTitle} partners with office parks, residential communities, breweries, and other properties to bring regular food ${vehicleType} service. Visit our services page to learn about our property programs, or contact us directly to discuss scheduling.`
  },
  {
    question: `What areas does ${siteTitle} serve?`,
    answer: `We serve ${cityName}, Bellevue, Redmond, Kirkland, Tacoma, and the greater Puget Sound area. Our network of food ${vehicleType}s can travel throughout Western Washington for events of all sizes.`
  },
  {
    question: `How much does food ${vehicleType} catering cost?`,
    answer: `Food ${vehicleType} catering costs vary depending on the number of guests, menu selections, service duration, and event location. Most events range from $15–$35 per person. Visit our pricing page for detailed cost estimates and use our interactive cost calculator to get a quick estimate for your event.`
  },
  {
    question: 'How do I contact support?',
    answer: `You can reach our support team by phone at (206) 799-0095 or by email at ${supportEmail}. We're available Monday through Friday, 9am to 5pm PST. We typically respond to emails within one business day.`
  },
  {
    question: `What are ${siteTitle}'s hours of operation?`,
    answer: `Our support team is available Monday through Friday, 9am to 5pm PST. You can reach us by phone at (206) 799-0095 or email at ${supportEmail} during business hours. Catering requests submitted outside of business hours will be reviewed the next business day.`
  }
];

function SupportFaq() {
  const { city_name, site_title, vehicle_type, support_email } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getSupportFaqQuestions(city_name, site_title, vehicleType, support_email);

  return (
    <Faq questions={questions} />
  );
}

export default SupportFaq;
